import axios from 'axios';
import { XV2AppLoader } from '@nab/x-app-loaders';
import type { CrossDomainApp, XV2App, App, EnvScopesConfig } from '@nab/x-types';
import { getUrlAndFolderPath } from './getUrlAndFolderPath';

export function getDocumentDefaultBaseUrl(): string {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return '';
    }

    return document.querySelector('base')?.href || window.location.origin;
}

export function getScopesBaseUrl({ assetManifestUrl, url }: Partial<XV2App & CrossDomainApp & App>, defaultBaseUrl: string): string {
    return assetManifestUrl || url ? getUrlAndFolderPath(assetManifestUrl || url) : defaultBaseUrl;
}

export async function getScopes(appMetaData: Partial<XV2App & CrossDomainApp & App>): Promise<EnvScopesConfig[]> {
    const scopes = XV2AppLoader.getAppLoaderInstance(appMetaData.id)?.appInstanceData?.scopes;
    if (scopes) {
        return scopes;
    }
    const defaultScopesBaseUrl = getDocumentDefaultBaseUrl();
    const scopesBaseUrl = getScopesBaseUrl(appMetaData, defaultScopesBaseUrl);
    const scopesConfigFileUrl: string = `${scopesBaseUrl.replace(/\/$/, '')}/scopes.json`;
    try {
        const resp = await axios.get<EnvScopesConfig[]>(scopesConfigFileUrl);
        return resp.data;
    } catch (e) {
        throw new Error(`${e && e.response && e.response.status}`);
    }
}
